import { Field } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  addActiveFn,
  pushToParams,
  pushWithRow,
  requestTo,
  withNewTitle,
} from "../../components/action-buttons/ActionButtonGenerator";
import TextInput from "../../components/form-fields/TextInput";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import { useTranslation } from "react-i18next";
import CreateUser from "./CreateUser";
import { Accordion, Button, Card } from "react-bootstrap";
import Filters from "../../components/list/Filters";
import Select from "../../components/form-fields/Select";

import { Link, useHistory } from "react-router-dom";

import UserModal from "./UserModal";


export default function Users() {
  const [showModal, setShowModal] = useState(false);
  
  const [refreshList, setRefreshList] = useState(false);
  
  const [isUpdating, setIsUpdating] = useState(false);
  
  const [initialValuesArchive, setInitialValuesArchive] = useState({
    id: null,
    arsivYonetimIds: null,
  });
  
  const [selectedRow, setSelectedRow] = useState(null);
  const [t, i18n] = useTranslation(); /* Added Line */
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("filter");
  const [filters, setFilters] = useState([]);
  const [configData, setConfigData] = useState(null);
  
  const history = useHistory();
  
  const [StatusCheckBoxValue, setStatusCheckBoxValue] = useState(false);
  const [MasrafCheckBoxVal, setMasrafCheckBoxVal] = useState(null);

  
  
  const onFileUpdateButtonClicked = (selectedRow) => {
    /* setShowFileModal(true); */
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };
  
  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
    const { stId } = selectedRow;
    if (stId === 90) setStatusCheckBoxValue(true);
    else setStatusCheckBoxValue(false);
  };

  const onArchiveUpdateButtonClicked = (selectedRow) => {
    setInitialValuesArchive({ id: null, arsivYonetimIds: null });
    /* setShowArchiveModal(true); */
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };
  const linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Button className="btn-xs"
        onClick={() => {
          onUpdateButtonClicked(row);
        }}
      >
        <i className="fa fa-search color-white"></i>
      </Button>
    );
  };
  return (
    <Main>
      <div className={"row"}>
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="filter"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                  } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    configPointUrl="user/config"
                    // configParameterName="talepTurId"
                    // configParameterValue={16}
                    // configReqType={"POST"}
                    setConfigData={(data) => setConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                  >
                    <Field
                      name="fullName"
                      label={`${t("demandList.adiSoyadi")}`}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="username"
                      label={`${t("demandList.userName")}`}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="userRoleId"
                      label={t("demandList.kullaniciRolu")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.roles}
                    />
                    <Field
                      name="durumId"
                      label={t("demandList.durum")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.durum}
                    />
                    <Field
                      name="eposta"
                      label={`${t("demandList.ePosta")}`}
                      colNumber="3"
                      component={TextInput}
                    />
                    <Field
                      name="sirketID"
                      label={t("davaIcraSavcilik.grupSirketi")}
                      colNumber="3"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.companies}
                    />
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
        {/* yeni kullanıcı ekleme */}
      </div>
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <CreateUser
            refreshList={refreshList}
            setRefreshList={setRefreshList}
          />
          {/* kullanıcı arşiv ve yönetimi kontrolleri */}
          <UserModal 
            showModal={showModal} 
            setShowModal={setShowModal} 
            isUpdating={isUpdating}
            selectedRow={selectedRow}
            refreshList={refreshList}
            setRefreshList={setRefreshList}
            StatusCheckBoxValue={StatusCheckBoxValue}
            initialValuesArchive={initialValuesArchive}
            setInitialValuesArchive={setInitialValuesArchive}
          />
        </div>

        <div className="row">
          <div className="col-md-12">
            <ListComponent
              entityName="kullanıcılar"
              endpoint="user/list"
              keyField="id"
              refreshList={refreshList}
              hideSelection={true}
              customBody={{
                filters: filters,
              }}
              columns={[
                {
                  dataField: "id",
                  text: "ID",
                  sort: true,
                  headerClasses: "id-header",
                },

                {
                  dataField: "username",
                  text: `${t("demandList.kullaniciAdi")}`,
                  sort: true,
                },
                {
                  dataField: "fullName",
                  text: `${t("demandList.adiSoyadi")}`,
                  sort: true,
                },
                {
                  dataField: "avukatKod",
                  text: `${t("demandList.avukatKodu")}`,
                  sort: true,
                },
                {
                  dataField: "email",
                  text: `${t("demandList.ePosta")}`,
                  sort: true,
                },
                {
                  dataField: "statusName",
                  text: `${t("demandList.durum")}`,
                  sort: true,
                },
                {
                  dataField: "masrafCheck",
                  text: `${t("demandList.masrafCheck")}`,
                  sort: true,
                  formatter: (data, row) => (row.masrafCheck ? t("demandList.durumAktif") : t("demandList.durumPasif")),
                },
                {
                  dataField: "",
                  text: "İşlemler",
                  formatter: linkFollow,
                  sort: false,
                },
              ]}
              actionButtonsObject={{
                actions: [
                  pushToParams(ABT.EDIT, onUpdateButtonClicked),
                  pushToParams(ABT.ARCHIVE, onArchiveUpdateButtonClicked),
                  pushToParams(ABT.UPLOAD_USER_FILES, onFileUpdateButtonClicked),
                  requestTo(ABT.ACTIVE, "user/aktif-pasif"),
                  requestTo(ABT.PASSIVE, "user/aktif-pasif"),
                  pushWithRow(
                    withNewTitle(ABT.GOTOPAGE, "userRole.roller"),
                    "/kullanıcı-rol"
                  ),
                  pushWithRow(
                    withNewTitle(ABT.GOTOPAGETWO, "userDepartment.departmanlar"),
                    "/kullanıcı-departman"
                  ),
                  pushToParams(ABT.EXCEL_EXPORT, {
                    requestTo: "file/download-excel-user",
                  }),
                ],
                generator: DefaultActionButtonGenerator,
              }}
            />
          </div>
        </div>
      </div>

    </Main>
  );
}
